import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_flexcol _my-4",
  "data-qa": "applicable-tax-wrapper"
}
const _hoisted_2 = { class: "gfu-heading gfu-heading--top-divider _mb-2" }
const _hoisted_3 = {
  ref: "locationField",
  class: "gfu-1of1 gfu-1of2--m"
}
const _hoisted_4 = {
  key: 0,
  class: "gfu-1of1 gfu-1of2--m"
}
const _hoisted_5 = {
  key: 1,
  class: "gfu-grid__cell gfu-1of1 gfu-1of2--m",
  "data-qa": "tax-identification-number-section"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_customer_entity_type_selection = _resolveComponent("customer-entity-type-selection")
  const _component_auto_complete_field = _resolveComponent("auto-complete-field")
  const _component_text_field = _resolveComponent("text-field")
  const _component_vat_reverse_checkbox = _resolveComponent("vat-reverse-checkbox")
  const _component_cart_table_notificator = _resolveComponent("cart-table-notificator")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.CheckoutLocationDetailsSectionTitle), 1 /* TEXT */),
    _createVNode(_component_customer_entity_type_selection, {
      "model-value": $data.model.isBusinessEntity,
      "read-only": $options.isReadOnly,
      "onUpdate:modelValue": $options.handleCustomerEntityChange
    }, null, 8 /* PROPS */, ["model-value", "read-only", "onUpdate:modelValue"]),
    _createElementVNode("div", _hoisted_3, [
      ($options.hasLocations)
        ? (_openBlock(), _createBlock(_component_auto_complete_field, {
            key: 0,
            modelValue: $data.model.projectLocationID,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = $event => (($data.model.projectLocationID) = $event)),
              $options.onProjectLocationChanged
            ],
            "display-name": _ctx.Resources.Checkout.UserShippingCountryLabel,
            name: "model.projectLocationID",
            items: _ctx.projectLocationsList,
            description: $options.inputDescription,
            "min-chars": 0,
            placeholder: _ctx.Resources.Checkout.UserShippingCountryPlaceholder,
            "read-only": $options.isReadOnly,
            "item-name-finder": item => item.name,
            "item-value-finder": item => item.projectLocationID,
            autocomplete: "off",
            "data-qa": "applicable-tax-shipping-section"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "items", "description", "placeholder", "read-only", "item-name-finder", "item-value-finder", "onUpdate:modelValue"]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */),
    ($options.isLocationWithSubLocations)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_auto_complete_field, {
            modelValue: $data.model.projectSubLocationID,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = $event => (($data.model.projectSubLocationID) = $event)),
              $options.onProjectSubLocationChanged
            ],
            "display-name": _ctx.Resources.Checkout.UserSubLocationLabel,
            name: "model.projectSubLocationID",
            items: $options.projectSubLocations,
            placeholder: _ctx.Resources.Checkout.UserSubLocationPlaceholder,
            "min-chars": 0,
            "read-only": $options.isReadOnly,
            "item-name-finder": item => item.name,
            "item-value-finder": item => item.projectSubLocationID,
            "data-qa": "applicable-tax-shipping-sublocation"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "items", "placeholder", "read-only", "item-name-finder", "item-value-finder", "onUpdate:modelValue"])
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isTaxIdentificationNumberSectionVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_text_field, {
            modelValue: $data.model.vatNumber,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.vatNumber) = $event)),
            name: "model.vatNumber",
            "display-name": $options.customerVatNumberFieldName,
            "tooltip-text": $options.customerVatNumberFieldRule?.tooltip,
            disabled: $options.isReadOnly,
            onBlur: $options.onVatNumberBlur
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "tooltip-text", "disabled", "onBlur"])
        ]))
      : _createCommentVNode("v-if", true),
    ($options.isRegisteredVatPayerCheckboxVisible)
      ? (_openBlock(), _createBlock(_component_vat_reverse_checkbox, {
          key: 2,
          modelValue: $data.model.isRegisteredVatPayer,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = $event => (($data.model.isRegisteredVatPayer) = $event)),
            $options.onCheckboxChange
          ],
          class: "_mt-1",
          "tax-regulation": $options.projectLocation.taxRegulation,
          disabled: $options.isVatReverseCheckboxReadonly,
          "data-qa": "registered-vat-payer-section"
        }, null, 8 /* PROPS */, ["modelValue", "tax-regulation", "disabled", "onUpdate:modelValue"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_cart_table_notificator, { "checkout-return-action-url": $props.checkoutReturnActionUrl }, null, 8 /* PROPS */, ["checkout-return-action-url"])
  ]))
}